<template>
  <tr>
    <td>{{title}}</td>
    <td v-if="localType==='label'||localType===null">
      {{input}}
      <slot name="body">
      </slot>
    </td>
    <td v-if="localType==='label_tag'">
      {{$store.state.tags[tagCategory][input].tag_name}}
    </td>
    <td v-if="localType==='textarea'"><textarea v-model="input" class="form-control" :rows="rows"></textarea></td>
    <td v-if="localType==='text'"><input type="text" v-model="input"></td>
    <td v-if="localType==='select'">
      <select v-model="input" class="form-control">
        <option v-if="tags" v-for="tag in tags">{{tag.tag_name}}</option>
      </select>
    </td>
    <td v-if="type==='button'">
      <button class="btn btn-block btn-primary" v-on:click="click">{{title}}</button>
    </td>
    <td v-if="type==='html'" v-html="input.replace(/\n/g,'<br/>')">
    </td>
  </tr>
</template>

<script>
  export default {
    props: [
      'type',
      'title',
      'tags',
      'rows',
      'input',
      'tagCategory'
    ],
    data: function () {
      return {
        localType: this.type
      }
    },
    created: function () {
      if (!this.localType) {
        this.localType = 'label'
      }
    },
    methods: {
      click: function () {
        // @event="親のメソッド名" 渡されたボタンが実行されます
        this.$emit('event')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Row.vue?d602ba7e